import { render, staticRenderFns } from "./filer_backtest_app.vue?vue&type=template&id=38bba746&"
import script from "./filer_backtest_app.vue?vue&type=script&lang=js&"
export * from "./filer_backtest_app.vue?vue&type=script&lang=js&"
import style1 from "./filer_backtest_app.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports